interface Props {
  className?: string;
}

export default function LotusIcon({ className = "w-4 h-4" }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 4c-2 2.4-3 5-3 7.5 0 1.8.5 3.6 1.5 5.2.3.5.7.8 1.5.8s1.2-.3 1.5-.8c1-1.6 1.5-3.4 1.5-5.2 0-2.5-1-5.1-3-7.5z" />
      <path d="M3 9c-.4 2.6.4 5.2 2.2 7 1.2 1.2 2.8 1.9 4.4 2.1.4 0 .7-.2.9-.6.6-1.8.4-3.8-.5-5.5-1.2-2.2-3.5-3.6-6-3.8-.4 0-.9.3-1 .8z" />
      <path d="M21 9c.4 2.6-.4 5.2-2.2 7-1.2 1.2-2.8 1.9-4.4 2.1-.4 0-.7-.2-.9-.6-.6-1.8-.4-3.8.5-5.5 1.2-2.2 3.5-3.6 6-3.8.4 0 .9.3 1 .8z" />
    </svg>
  );
}
